import { useEffect, useState } from 'react';

/** Below this width the editor shows the phone layout (design f: sections in place of the timeline). */
export const PHONE_LAYOUT_MAX_PX = 719;

const QUERY = `(max-width: ${PHONE_LAYOUT_MAX_PX}px)`;

function matches(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.(QUERY).matches === true;
}

/** True on a screen narrower than 720 px (design f). It follows a resize and a rotation. */
export function useIsPhoneLayout(): boolean {
  const [isPhone, setIsPhone] = useState(matches);
  useEffect(() => {
    if (typeof window === 'undefined' || window.matchMedia === undefined) {
      return undefined;
    }
    const list = window.matchMedia(QUERY);
    const onChange = () => setIsPhone(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, []);
  return isPhone;
}
